'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Base2 = require('./Base');

var _Base3 = _interopRequireDefault(_Base2);

var _anotherJson = require('another-json');

var _anotherJson2 = _interopRequireDefault(_anotherJson);

var _Error = require('./Error');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENTS = ["m.key.verification.accept", "m.key.verification.key", "m.key.verification.mac"]; /*
                                                                                                Copyright 2018 New Vector Ltd
                                                                                                
                                                                                                Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                you may not use this file except in compliance with the License.
                                                                                                You may obtain a copy of the License at
                                                                                                
                                                                                                    http://www.apache.org/licenses/LICENSE-2.0
                                                                                                
                                                                                                Unless required by applicable law or agreed to in writing, software
                                                                                                distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                See the License for the specific language governing permissions and
                                                                                                limitations under the License.
                                                                                                */

/**
 * Short Authentication String (SAS) verification.
 * @module crypto/verification/SAS
 */

var olmutil = void 0;

var newMismatchedSASError = (0, _Error.errorFactory)("m.mismatched_sas", "Mismatched short authentication string");

var newMismatchedCommitmentError = (0, _Error.errorFactory)("m.mismatched_commitment", "Mismatched commitment");

function generateDecimalSas(sasBytes) {
    /**
     *      +--------+--------+--------+--------+--------+
     *      | Byte 0 | Byte 1 | Byte 2 | Byte 3 | Byte 4 |
     *      +--------+--------+--------+--------+--------+
     * bits: 87654321 87654321 87654321 87654321 87654321
     *       \____________/\_____________/\____________/
     *         1st number    2nd number     3rd number
     */
    return [(sasBytes[0] << 5 | sasBytes[1] >> 3) + 1000, ((sasBytes[1] & 0x7) << 10 | sasBytes[2] << 2 | sasBytes[3] >> 6) + 1000, ((sasBytes[3] & 0x3f) << 7 | sasBytes[4] >> 1) + 1000];
}

var emojiMapping = [["🐶", "dog"], //  0
["🐱", "cat"], //  1
["🦁", "lion"], //  2
["🐎", "horse"], //  3
["🦄", "unicorn"], //  4
["🐷", "pig"], //  5
["🐘", "elephant"], //  6
["🐰", "rabbit"], //  7
["🐼", "panda"], //  8
["🐓", "rooster"], //  9
["🐧", "penguin"], // 10
["🐢", "turtle"], // 11
["🐟", "fish"], // 12
["🐙", "octopus"], // 13
["🦋", "butterfly"], // 14
["🌷", "flower"], // 15
["🌳", "tree"], // 16
["🌵", "cactus"], // 17
["🍄", "mushroom"], // 18
["🌏", "globe"], // 19
["🌙", "moon"], // 20
["☁️", "cloud"], // 21
["🔥", "fire"], // 22
["🍌", "banana"], // 23
["🍎", "apple"], // 24
["🍓", "strawberry"], // 25
["🌽", "corn"], // 26
["🍕", "pizza"], // 27
["🎂", "cake"], // 28
["❤️", "heart"], // 29
["🙂", "smiley"], // 30
["🤖", "robot"], // 31
["🎩", "hat"], // 32
["👓", "glasses"], // 33
["🔧", "spanner"], // 34
["🎅", "santa"], // 35
["👍", "thumbs up"], // 36
["☂️", "umbrella"], // 37
["⌛", "hourglass"], // 38
["⏰", "clock"], // 39
["🎁", "gift"], // 40
["💡", "light bulb"], // 41
["📕", "book"], // 42
["✏️", "pencil"], // 43
["📎", "paperclip"], // 44
["✂️", "scisors"], // 45
["🔒", "padlock"], // 46
["🔑", "key"], // 47
["🔨", "hammer"], // 48
["☎️", "telephone"], // 49
["🏁", "flag"], // 50
["🚂", "train"], // 51
["🚲", "bicycle"], // 52
["✈️", "aeroplane"], // 53
["🚀", "rocket"], // 54
["🏆", "trophy"], // 55
["⚽", "ball"], // 56
["🎸", "guitar"], // 57
["🎺", "trumpet"], // 58
["🔔", "bell"], // 59
["⚓️", "anchor"], // 60
["🎧", "headphones"], // 61
["📁", "folder"], // 62
["📌", "pin"]];

function generateEmojiSas(sasBytes) {
    var emojis = [
    // just like base64 encoding
    sasBytes[0] >> 2, (sasBytes[0] & 0x3) << 4 | sasBytes[1] >> 4, (sasBytes[1] & 0xf) << 2 | sasBytes[2] >> 6, sasBytes[2] & 0x3f, sasBytes[3] >> 2, (sasBytes[3] & 0x3) << 4 | sasBytes[4] >> 4, (sasBytes[4] & 0xf) << 2 | sasBytes[5] >> 6];

    return emojis.map(function (num) {
        return emojiMapping[num];
    });
}

function generateSas(sasBytes, methods) {
    var sas = {};
    if (methods.includes("decimal")) {
        sas["decimal"] = generateDecimalSas(sasBytes);
    }
    if (methods.includes("emoji")) {
        sas["emoji"] = generateEmojiSas(sasBytes);
    }
    return sas;
}

/**
 * @alias module:crypto/verification/SAS
 * @extends {module:crypto/verification/Base}
 */

var SAS = function (_Base) {
    (0, _inherits3.default)(SAS, _Base);

    function SAS() {
        (0, _classCallCheck3.default)(this, SAS);
        return (0, _possibleConstructorReturn3.default)(this, (SAS.__proto__ || (0, _getPrototypeOf2.default)(SAS)).apply(this, arguments));
    }

    (0, _createClass3.default)(SAS, [{
        key: '_doVerification',
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return (0, _bluebird.resolve)(global.Olm.init());

                            case 2:
                                olmutil = olmutil || new global.Olm.Utility();

                                // make sure user's keys are downloaded
                                _context.next = 5;
                                return (0, _bluebird.resolve)(this._baseApis.downloadKeys([this.userId]));

                            case 5:
                                if (!this.startEvent) {
                                    _context.next = 11;
                                    break;
                                }

                                _context.next = 8;
                                return (0, _bluebird.resolve)(this._doRespondVerification());

                            case 8:
                                return _context.abrupt('return', _context.sent);

                            case 11:
                                _context.next = 13;
                                return (0, _bluebird.resolve)(this._doSendVerification());

                            case 13:
                                return _context.abrupt('return', _context.sent);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _doVerification() {
                return _ref.apply(this, arguments);
            }

            return _doVerification;
        }()
    }, {
        key: '_doSendVerification',
        value: function () {
            var _ref2 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var _this2 = this;

                var initialMessage, e, content, hashCommitment, sasMethods, olmSAS, commitmentStr, sasInfo, sasBytes, verifySAS, _ref3, _ref4;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                initialMessage = {
                                    method: SAS.NAME,
                                    from_device: this._baseApis.deviceId,
                                    key_agreement_protocols: ["curve25519"],
                                    hashes: ["sha256"],
                                    message_authentication_codes: ["hmac-sha256"],
                                    // FIXME: allow app to specify what SAS methods can be used
                                    short_authentication_string: ["decimal", "emoji"],
                                    transaction_id: this.transactionId
                                };

                                this._sendToDevice("m.key.verification.start", initialMessage);

                                _context2.next = 4;
                                return (0, _bluebird.resolve)(this._waitForEvent("m.key.verification.accept"));

                            case 4:
                                e = _context2.sent;
                                content = e.getContent();

                                if (content.key_agreement_protocol === "curve25519" && content.hash === "sha256" && content.message_authentication_code === "hmac-sha256" && content.short_authentication_string instanceof Array && (content.short_authentication_string.includes("decimal") || content.short_authentication_string.includes("emoji"))) {
                                    _context2.next = 8;
                                    break;
                                }

                                throw (0, _Error.newUnknownMethodError)();

                            case 8:
                                if (!(typeof content.commitment !== "string")) {
                                    _context2.next = 10;
                                    break;
                                }

                                throw (0, _Error.newInvalidMessageError)();

                            case 10:
                                hashCommitment = content.commitment;
                                sasMethods = content.short_authentication_string;
                                olmSAS = new global.Olm.SAS();
                                _context2.prev = 13;

                                this._sendToDevice("m.key.verification.key", {
                                    key: olmSAS.get_pubkey()
                                });

                                _context2.next = 17;
                                return (0, _bluebird.resolve)(this._waitForEvent("m.key.verification.key"));

                            case 17:
                                e = _context2.sent;

                                // FIXME: make sure event is properly formed
                                content = e.getContent();
                                commitmentStr = content.key + _anotherJson2.default.stringify(initialMessage);

                                if (!(olmutil.sha256(commitmentStr) !== hashCommitment)) {
                                    _context2.next = 22;
                                    break;
                                }

                                throw newMismatchedCommitmentError();

                            case 22:
                                olmSAS.set_their_key(content.key);

                                sasInfo = "MATRIX_KEY_VERIFICATION_SAS" + this._baseApis.getUserId() + this._baseApis.deviceId + this.userId + this.deviceId + this.transactionId;
                                sasBytes = olmSAS.generate_bytes(sasInfo, 6);
                                verifySAS = new _promise2.default(function (resolve, reject) {
                                    _this2.emit("show_sas", {
                                        sas: generateSas(sasBytes, sasMethods),
                                        confirm: function confirm() {
                                            _this2._sendMAC(olmSAS);
                                            resolve();
                                        },
                                        cancel: function cancel() {
                                            return reject((0, _Error.newUserCancelledError)());
                                        },
                                        mismatch: function mismatch() {
                                            return reject(newMismatchedSASError());
                                        }
                                    });
                                });
                                _context2.next = 28;
                                return (0, _bluebird.resolve)(_promise2.default.all([this._waitForEvent("m.key.verification.mac"), verifySAS]));

                            case 28:
                                _ref3 = _context2.sent;
                                _ref4 = (0, _slicedToArray3.default)(_ref3, 1);
                                e = _ref4[0];

                                content = e.getContent();
                                _context2.next = 34;
                                return (0, _bluebird.resolve)(this._checkMAC(olmSAS, content));

                            case 34:
                                _context2.prev = 34;

                                olmSAS.free();
                                return _context2.finish(34);

                            case 37:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[13,, 34, 37]]);
            }));

            function _doSendVerification() {
                return _ref2.apply(this, arguments);
            }

            return _doSendVerification;
        }()
    }, {
        key: '_doRespondVerification',
        value: function () {
            var _ref5 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
                var _this3 = this;

                var content, olmSAS, sasMethods, commitmentStr, e, sasInfo, sasBytes, verifySAS, _ref6, _ref7;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                content = this.startEvent.getContent();

                                if (content.key_agreement_protocols instanceof Array && content.key_agreement_protocols.includes("curve25519") && content.hashes instanceof Array && content.hashes.includes("sha256") && content.message_authentication_codes instanceof Array && content.message_authentication_codes.includes("hmac-sha256") && content.short_authentication_string instanceof Array && (content.short_authentication_string.includes("decimal") || content.short_authentication_string.includes("emoji"))) {
                                    _context3.next = 3;
                                    break;
                                }

                                throw (0, _Error.newUnknownMethodError)();

                            case 3:
                                olmSAS = new global.Olm.SAS();
                                sasMethods = [];
                                // FIXME: allow app to specify what SAS methods can be used

                                if (content.short_authentication_string.includes("decimal")) {
                                    sasMethods.push("decimal");
                                }
                                if (content.short_authentication_string.includes("emoji")) {
                                    sasMethods.push("emoji");
                                }
                                _context3.prev = 7;
                                commitmentStr = olmSAS.get_pubkey() + _anotherJson2.default.stringify(content);

                                this._sendToDevice("m.key.verification.accept", {
                                    key_agreement_protocol: "curve25519",
                                    hash: "sha256",
                                    message_authentication_code: "hmac-sha256",
                                    short_authentication_string: sasMethods,
                                    commitment: olmutil.sha256(commitmentStr)
                                });

                                _context3.next = 12;
                                return (0, _bluebird.resolve)(this._waitForEvent("m.key.verification.key"));

                            case 12:
                                e = _context3.sent;

                                // FIXME: make sure event is properly formed
                                content = e.getContent();
                                olmSAS.set_their_key(content.key);
                                this._sendToDevice("m.key.verification.key", {
                                    key: olmSAS.get_pubkey()
                                });

                                sasInfo = "MATRIX_KEY_VERIFICATION_SAS" + this.userId + this.deviceId + this._baseApis.getUserId() + this._baseApis.deviceId + this.transactionId;
                                sasBytes = olmSAS.generate_bytes(sasInfo, 6);
                                verifySAS = new _promise2.default(function (resolve, reject) {
                                    _this3.emit("show_sas", {
                                        sas: generateSas(sasBytes, sasMethods),
                                        confirm: function confirm() {
                                            _this3._sendMAC(olmSAS);
                                            resolve();
                                        },
                                        cancel: function cancel() {
                                            return reject((0, _Error.newUserCancelledError)());
                                        },
                                        mismatch: function mismatch() {
                                            return reject(newMismatchedSASError());
                                        }
                                    });
                                });
                                _context3.next = 21;
                                return (0, _bluebird.resolve)(_promise2.default.all([this._waitForEvent("m.key.verification.mac"), verifySAS]));

                            case 21:
                                _ref6 = _context3.sent;
                                _ref7 = (0, _slicedToArray3.default)(_ref6, 1);
                                e = _ref7[0];

                                content = e.getContent();
                                _context3.next = 27;
                                return (0, _bluebird.resolve)(this._checkMAC(olmSAS, content));

                            case 27:
                                _context3.prev = 27;

                                olmSAS.free();
                                return _context3.finish(27);

                            case 30:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[7,, 27, 30]]);
            }));

            function _doRespondVerification() {
                return _ref5.apply(this, arguments);
            }

            return _doRespondVerification;
        }()
    }, {
        key: '_sendMAC',
        value: function _sendMAC(olmSAS) {
            var keyId = 'ed25519:' + this._baseApis.deviceId;
            var mac = {};
            var baseInfo = "MATRIX_KEY_VERIFICATION_MAC" + this._baseApis.getUserId() + this._baseApis.deviceId + this.userId + this.deviceId + this.transactionId;

            mac[keyId] = olmSAS.calculate_mac(this._baseApis.getDeviceEd25519Key(), baseInfo + keyId);
            var keys = olmSAS.calculate_mac(keyId, baseInfo + "KEY_IDS");
            this._sendToDevice("m.key.verification.mac", { mac: mac, keys: keys });
        }
    }, {
        key: '_checkMAC',
        value: function () {
            var _ref8 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(olmSAS, content) {
                var baseInfo;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                baseInfo = "MATRIX_KEY_VERIFICATION_MAC" + this.userId + this.deviceId + this._baseApis.getUserId() + this._baseApis.deviceId + this.transactionId;

                                if (!(content.keys !== olmSAS.calculate_mac((0, _keys2.default)(content.mac).sort().join(","), baseInfo + "KEY_IDS"))) {
                                    _context4.next = 3;
                                    break;
                                }

                                throw (0, _Error.newKeyMismatchError)();

                            case 3:
                                _context4.next = 5;
                                return (0, _bluebird.resolve)(this._verifyKeys(this.userId, content.mac, function (keyId, device, keyInfo) {
                                    if (keyInfo !== olmSAS.calculate_mac(device.keys[keyId], baseInfo + keyId)) {
                                        throw (0, _Error.newKeyMismatchError)();
                                    }
                                }));

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function _checkMAC(_x, _x2) {
                return _ref8.apply(this, arguments);
            }

            return _checkMAC;
        }()
    }, {
        key: 'events',
        get: function get() {
            return EVENTS;
        }
    }]);
    return SAS;
}(_Base3.default);

exports.default = SAS;


SAS.NAME = "m.sas.v1";
//# sourceMappingURL=SAS.js.map